import { TagIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { TagObjectFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Adds or removes tags on the contact moving through the workflow. */
export function TagObjectNode({ data, selected }: NodeProps<TagObjectFlowNode>) {
  const verb = data.operation === `remove` ? `Remove` : `Add`
  const on = data.target === `activity` ? ` on activity` : ` on contact`
  const summary = data.tags.length ? `${verb} ${data.tags.join(`, `)}${on}` : `No tags selected`
  return (
    <NodeShell icon={TagIcon} accent="orange" kind="Tag" label={data.label} description={summary} selected={selected} />
  )
}
